import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/accessibility/de/en';
import { AccessibilityPageTemplate } from '@/pageTemplate/AccessibilityPageTemplate';
import { useEffect } from 'react';

export default function AccessibilityPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('accessibility_page.viewed', {
        variant: 'default',
      }),
    [],
  );

  return <AccessibilityPageTemplate config={config} />;
}
